import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

export interface InventoryState {
    showZeroQuantityOrders: boolean;
}

const initialState: InventoryState = {
    showZeroQuantityOrders: false,
};

export const inventorySlice = createSlice({
    name: "inventory",
    initialState,
    reducers: {
        setShowZeroQuantityOrders: (state, action: PayloadAction<boolean>) => {
            state.showZeroQuantityOrders = action.payload;
        },
    },
});

export const { setShowZeroQuantityOrders } = inventorySlice.actions;

export const selectInventory = (state: RootState) => state.inventory;
export default inventorySlice.reducer;
